import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PROBLEMS } from "@/data/site";
import { ToothIcon } from "@/components/common/ToothIcon";
import { Reveal } from "@/components/common/Reveal";

export const ProblemsGrid = () => (
  <section data-testid="problems-section" className="bg-white">
    <div className="mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-32 lg:px-20 lg:py-40">
      <div className="mb-14 grid gap-6 lg:grid-cols-[1.1fr_0.9fr] lg:items-end">
        <Reveal>
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-brand-blue">
            Common Dental Problems
          </span>
          <h2 className="mt-5 font-display text-4xl font-semibold leading-[1.02] tracking-tight text-brand-dark md:text-5xl lg:text-6xl">
            Are you experiencing any of <span className="italic text-brand-blue">these?</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:justify-self-end">
          <p className="max-w-sm text-brand-muted">
            Don&apos;t ignore the early signs. Identify your symptom and find the right treatment — early
            care means simpler, more affordable solutions.
          </p>
        </Reveal>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {PROBLEMS.map((p, i) => (
          <Reveal key={p.slug} delay={(i % 4) * 0.06}>
            <Link
              to={`/problems/${p.slug}`}
              data-testid={`problem-card-${p.slug}`}
              className="group flex h-full flex-col rounded-2xl border border-brand-line bg-brand-soft p-5 transition-all duration-300 hover:-translate-y-1 hover:bg-brand-blue"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-white text-brand-blue">
                <ToothIcon className="h-4 w-4" />
              </span>
              <h3 className="mt-4 font-display text-lg font-medium text-brand-dark transition-colors group-hover:text-white">
                {p.name}
              </h3>
              <p className="mt-2 flex-1 text-sm text-brand-muted transition-colors group-hover:text-white/80">
                {p.short}
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-brand-blue transition-colors group-hover:text-white">
                Find treatment
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
